// third-party
import { createSlice } from '@reduxjs/toolkit';

// project import
import ContactCategoryDto from 'common/dto-types/contacts/contact-category-dto';

type ContactCategorySliceStates = {
    data?: ContactCategoryDto;
    isFormOpen: boolean;
};

const initialState: ContactCategorySliceStates = {
    isFormOpen: false,
};

const contactCategory = createSlice({
    name: 'contactCategory',
    initialState,
    reducers: {
        setContactCategory(state, action) {
            state.data = action.payload;
        },

        openContactCategoryForm(state) {
            state.isFormOpen = true;
        },

        closeContactCategoryForm(state) {
            state.data = undefined;
            state.isFormOpen = false;
        },
    },
});

export default contactCategory.reducer;

export const { openContactCategoryForm, closeContactCategoryForm, setContactCategory } = contactCategory.actions;
